import { CoreService } from './../../services/core.service';
import { Component, OnInit } from '@angular/core';

import {
  APP_HEADER,
  APP_SUB_HEADER,
} from './../../../shared/constants/constant';
import { MasterService } from '../../../shared/service/master.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  public showMenu = false;
  public menus;
  public header = APP_HEADER;
  public subHeader = APP_SUB_HEADER;
  public annualReporting;

  constructor(
    private coreService: CoreService,
    private masterService: MasterService,
  ) {}

  ngOnInit(): void {
    this.menus = this.coreService.getHemburgerMenus();
    this.coreService.updateReportingYear.subscribe(() => {
      this.setReportingCycleName();
    });
    this.setReportingCycleName();
  }

  setReportingCycleName(): void {
    this.masterService.getReportingCycleYear().subscribe((response) => {
      this.annualReporting = `${response.reportingCycleCode} Annual Reporting`;
      this.coreService.reportingCycleCode = response.reportingCycleCode;

      // update session
      sessionStorage.setItem(
        'currentReportingCycleYear',
        response.reportingCycleCode,
      );
      sessionStorage.setItem(
        'isCurrentReportingCycleYearLock',
        response.isLocked,
      );
      sessionStorage.setItem(
        'CurrentReportingCycleYearLockDate',
        response.creationDate,
      );
      this.coreService.updateReportingYearHeader.next(
        response.reportingCycleCode,
      );
    });
  }

  public onFocusout(): void {
    this.showMenu = false;
  }
}
